import { AxiosInstance, AxiosStatic } from "axios";
import {
  AxiosHookManager,
  injectAxiosInterceptorHook,
  injectAxiosTransformerHook
} from "./hook";
import { AxiosPlugin } from "./types";

export class AxiosPluginManager {
  interceptor: AxiosHookManager;
  transformer: AxiosHookManager;
  constructor(private axios: AxiosInstance | AxiosStatic) {
    this.interceptor = new AxiosHookManager(
      this.axios,
      injectAxiosInterceptorHook
    );
    this.transformer = new AxiosHookManager(
      this.axios,
      injectAxiosTransformerHook
    );
  }
  load<T>(plugin: AxiosPlugin<T>, options?: T) {
    return plugin.install(this.axios, options);
  }
  use<T>(plugin: AxiosPlugin<T>, options?: T) {
    const hook = plugin.install(this.axios, options);
    this.interceptor.use(hook);
    this.transformer.use(hook);
    return this;
  }
}

export function useAxiosPluginManager(axios: AxiosInstance | AxiosStatic) {
  axios.plugin = new AxiosPluginManager(axios);
}

declare module "axios" {
  interface AxiosInstance {
    plugin: AxiosPluginManager;
  }
}
